import { useCallback } from 'react';
import { bridge } from '../../../../../utils';
import type { IScreensLogging } from '../../../../../api/types/IScreenLogging';
import type { PromotionShortBannerEntity } from '../types';

export const useLogClickShortBanner = (logging: IScreensLogging) => {
  return useCallback(
    (entity: PromotionShortBannerEntity) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_SHORT_BANNER',
        analytics: {
          ...logging?.analytics,
          ...entity.logging?.analytics,
        },
        ably_only_log: {
          ...logging?.ably_only_log,
          ...entity.logging?.ably_only_log,
        },
      });
    },
    [logging],
  );
};
